import authAxios from 'modules/shared/axios/authAxios';

export default class BotService {
  static async update(id, data) {
    const body = {
      id,
      data,
    };

    const response = await authAxios.put(
      `/bot/${id}`,
      body,
    );

    return response.data;
  }

  static async destroyAll(ids) {
    const params = {
      ids,
    };

    const response = await authAxios.delete(`/bot`, {
      params,
    });

    return response.data;
  }

  static async create(data) {
    const body = {
      data,
    };

    const response = await authAxios.post(
      `/bot`,
      body,
    );

    return response.data;
  }

  static async import(values, importHash) {
    const body = {
      data: values,
      importHash,
    };

    const response = await authAxios.post(
      `/bot/import`,
      body,
    );

    return response.data;
  }

  static async find(id) {
    const response = await authAxios.get(`/bot/${id}`);
    return response.data;
  }

  static async list(filter, orderBy, limit, offset) {
    const params = {
      filter,
      orderBy,
      limit,
      offset,
    };

    const response = await authAxios.get(`/bot`, {
      params,
    });

    return response.data;
  }

  static async listMessages(id) {
    const response = await authAxios.get(`/bot/${id}/messages`);
    return response.data;
  }

  static async getMessageDetails(id, phoneNumber) {
    const response = await authAxios.get(`/bot/${id}/messages/${phoneNumber}`);
    return response.data;
  }

  static async listAutocomplete(query, limit) {
    const params = {
      query,
      limit,
    };

    const response = await authAxios.get(
      `/bot/autocomplete`,
      {
        params,
      },
    );

    return response.data;
  }
}
